/* global akdev_vars */
import './assets/sass/main.sass'
import $ from 'jquery'

$(document).ready(function () {
  $('.contacts-button').click(function () {
    $('#contact-modal').fadeIn()
    document.body.classList.add('body_clipped')
  })

  $('.modal__close').click(function () {
    $(this).parents('.modal').fadeOut()
    document.body.classList.remove('body_clipped')
  })

  $('#feedback-modal').submit(function (e) {
    e.preventDefault()
    const submitButton = $('#contact-form-submit')
    submitButton.addClass('button_loading')

    const form = $(this)
    // const nonce = $('input[name="nonce"]', form).val()

    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LerLy8nAAAAAN0vedQRA4S9F9fd852TIY0Lk2Oh', { action: 'submit' }).then(function (recaptchaToken) {
        $('input[name="recaptcha"]', form).val(recaptchaToken)

        const data = new FormData(form[0])
        data.append('action', 'feedback_form')

        fetch(akdev_vars.ajax_url, { method: 'POST', body: data })
          .then(res => res.json())
          .then(res => {
            submitButton.removeClass('button_loading')
            if (res.success) {
              submitButton.addClass('button_sent')
              submitButton.html('Done')
              $('#contact-form__name').val('')
              $('#contact-form__about').val('')
              $('#contact-form__email').val('')
              $('#contact-form__number').val('')
              setTimeout(() => {
                submitButton.removeClass('button_sent')
                submitButton.html('Submit')
              }, 2000)
            } else {
              alert('Ошибка: ' + res.data.message)
            }
          })
          .catch(() => {
            submitButton.removeClass('button_loading')
            alert('Ошибка при отправке формы')
          })
      })
    })
  })

  $('#nav__menu-button').click(function () {
    $('#nav').toggleClass('nav_active')
    $('body').toggleClass('body_clipped')
  })

  $('#main-page-get-in-touch-button').click(function () {
    $('html, body').animate({
      scrollTop: $('#main-page-get-in-touch').offset().top
    }, 1000)
  })
})



// WEBPACK FOOTER //
// ./src/main.js